<template>
  <v-container fluid>
    <!-- Filtros -->
    <v-row justify="center" class="mb-4">
        <v-col cols="12" md="2">
            <v-select hide-details dense outlined label="Tipo de producto" 
                v-model="payload.product_type_id" :items="product_types" item-value="id" item-text="name">
            </v-select>
        </v-col>
        <v-col cols="12" md="2">
            <v-select hide-details dense outlined label="Genero"
                v-model="payload.product_gender_id" :items="product_genders" item-value="id" item-text="name">
            </v-select>
        </v-col>
        <v-col cols="12" md="2">
            <v-select hide-details dense outlined label="Marca"
                v-model="payload.product_brand_id" :items="product_brands" item-value="id" item-text="name">
            </v-select>
        </v-col>
        <v-col cols="12" md="2">
            <v-select hide-details dense outlined label="Modelo" 
                v-model="payload.product_model" :items="product_models" item-value="name" item-text="name">
            </v-select>
        </v-col>
        <v-col cols="12" md="2">
            <v-select hide-details dense outlined label="Color" 
                v-model="payload.product_color_selection" :items="product_colors" item-value="id" item-text="name">
            </v-select>
        </v-col>
        <v-col cols="12" md="2">
            <v-select hide-details dense outlined label="Familia"
                v-model="payload.product_category_id" :items="product_categories" item-value="id" item-text="name">
            </v-select>
        </v-col>
        <v-col cols="12" md="2">
            <v-select hide-details dense outlined label="Corrida"
                v-model="payload.product_size_id" :items="product_size_collections" item-value="id" item-text="name">
            </v-select>
        </v-col>
        <v-col cols="12" md="2">
            <v-select hide-details dense outlined label="Material"
                v-model="payload.product_material_id" :items="product_materials" item-value="id" item-text="name">
            </v-select>
        </v-col>
        <v-col cols="12" md="2" class="d-flex align-center">
            <v-btn color="primary" @click="searchProducts">BUSCAR</v-btn>
            <v-btn color="grey" class="ml-2" @click="clearFilters">LIMPIAR</v-btn>
        </v-col>
    </v-row>

    <!-- Productos -->
    <v-row justify="center">
        <v-col cols="12" md="3" v-for="product in products" :key="product.id">
            <v-card>

                <div v-if="product.photo">
                    <img :src="getImageUrl(product.id, product.photo)" 
                        style="width: 100%; height: 200px; object-fit: cover;"
                        @load="handleImageLoad"
                        @error="handleImageError" />
                </div>

                <div v-else style="height: 200px; background: #f5f5f5; display: flex; align-items: center; justify-content: center;">
                    Sin imágenes
                </div>

                <v-card-text class="text-center">
                    <div><strong>{{ (product.brand && product.brand.name) || 'Sin marca' }}</strong></div>
                    <div>Color: {{ product.colors.map(c => c.name).join(', ') }}</div>
                    <div>Material: {{ product.materials.map(m => m.name).join(', ') }}</div>
                    <div>SKU: {{ product.sku }}</div>
                    <div>Corrida: {{ product.size_collection.name }}</div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>

  </v-container>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            payload: {
                product_type_id:null,
                product_gender_id:null,
                product_brand_id: null,
                product_model:null,
                product_color_selection: null,
                product_category_id:null,
                product_size_id:null,
                product_material_id: null,
            },

            product_types: [],
            product_genders: [],
            product_brands:[],
            product_models: [],
            product_colors: [],
            product_categories: [],
            product_size_collections : [],
            product_materials:  [],

            products: [],
        }
    },

    methods: {
        async searchProducts() {
            try {
                const {data} = await this.$axios.get('/admin/buscar', {params: this.payload});
                this.products = data;
            } catch (error){
                console.error('Error al buscar productos:', error);
            }
        },

        clearFilters() {
        for (let key in this.payload) {
            this.payload[key] = null;
        }
        this.products = [];
        },

        async loadSelects(){
            try {
                const {data} = await this.$axios.get('/admin/filtros');
                this.product_types = data.product_types;
                this.product_genders = data.product_genders;
                this.product_brands = data.product_brands;
                this.product_models = data.product_models;
                this.product_colors = data.product_colors;
                this.product_categories = data.product_categories;
                this.product_size_collections = data.product_size_collections;
                this.product_materials = data.product_materials;
            } catch(error) {
                console.error('Error al cargar filtros:', error);
            }
        },

         getImageUrl(productId, imageName) {
            if (!imageName || !productId) {
                return this.getPlaceholderImage();
            }
            
            //NOTAAAAAA ESTE SE DEBE DE CAMBIAR DE ACUERDO AL SERVIDOR, AL DOMINIO
            //return `http://dev.genscatalogo.com/images/products/${productId}/${imageName}`;
            return `http://genscatalogo.com/images/products/${productId}/${imageName}`;
            
        },
        
        getPlaceholderImage() {
            return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2Y1ZjVmNSIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkeT0iMC4zNWVtIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5Ij5TaW4gaW1hZ2VuPC90ZXh0Pjwvc3ZnPg==';
        },
        
        handleImageLoad(event) {
            console.log('Imagen cargada correctamente:', event.target.src);
        },
        
        handleImageError(event) {
            console.log('Error cargando imagen:', event.target.src);
            event.target.src = this.getPlaceholderImage();
        }
    },

    mounted() {
        this.loadSelects(); 
    }
}
</script>
